import { useCallback, useEffect } from 'react';
import { actionSetBreadcrumb } from '@/store/breadcrumbs';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { IBreadcrumb } from '@/types';
import { RootState } from 'src/store';

function useBreadcrumbs() {
  const breadcrumbs = useAppSelector((state: RootState) => state.breadcrumbs);
  const dispatch = useAppDispatch();

  const setBreadcrumbs = useCallback((activeMenu: string, breadcrumbs: IBreadcrumb[]) => {
    dispatch(actionSetBreadcrumb({ activeMenu, breadcrumbs }));
  }, []);

  return {
    breadcrumbs: breadcrumbs.breadcrumbs,
    activeMenu: breadcrumbs.activeMenu,
    setBreadcrumbs,
  };
}

function setBreadcrumbs(activeMenu: string, breadcrumbs: IBreadcrumb[]) {
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs(activeMenu, breadcrumbs);
  }, []);
}

export { useBreadcrumbs, setBreadcrumbs };
